/**
 * MOBILE PRODUCT NAVIGATION BAR
 * Shows a sticky top navbar on mobile when the user scrolls past
 * the Delivery Details section. Each button smooth-scrolls to a section.
 *
 * Page section order (from product.json):
 *   main (details) → scrolling-icons → reviews (Doran app) → related-products (explore)
 */
(function () {
    'use strict';

    // Bail on desktop
    if (window.innerWidth >= 750) return;

    var nav = document.getElementById('mobile-product-nav');
    if (!nav) return;

    /* ---- Trigger element (always present) ---- */
    var deliveryEl = document.querySelector('.gully-delivery');
    if (!deliveryEl) return;

    /* ---- DESCRIPTION accordion ---- */
    var descriptionEl = document.querySelector('details.gully-acc');

    /* ---- Targets object (explore & reviews filled later) ---- */
    var targets = {
        details: descriptionEl || deliveryEl,
        explore: null,
        reviews: null,
        top: null
    };

    var buttons = nav.querySelectorAll('.gl-mobile-nav__btn');

    /* ============================================================
       ELEMENT DISCOVERY — retries until async sections are loaded
       ============================================================ */
    function findExplore() {
        // 1. Find .related-products and get its shopify-section wrapper
        var rp = document.querySelector('.related-products');
        if (rp) return rp.closest('.shopify-section') || rp;
        // 2. Fallback: find shopify-section with "related" in ID
        var all = document.querySelectorAll('.shopify-section');
        for (var i = 0; i < all.length; i++) {
            if (all[i].id && all[i].id.indexOf('related') > -1) return all[i];
        }
        // 3. Fallback: find product-recommendations element
        var pr = document.querySelector('product-recommendations');
        if (pr) return pr.closest('.shopify-section') || pr;
        return null;
    }

    function findReviews() {
        // 1. Shopify section with the hash from product.json
        var all = document.querySelectorAll('.shopify-section');
        for (var i = 0; i < all.length; i++) {
            if (all[i].id && all[i].id.indexOf('1752569931') > -1) return all[i];
        }
        // 2. Fallback: any shopify-section with an app-block
        for (var i = 0; i < all.length; i++) {
            if (all[i].querySelector('.shopify-app-block')) return all[i];
        }
        return null;
    }

    // Retry discovery every 500ms for up to 5s
    var retryCount = 0;
    function discoverTargets() {
        if (!targets.explore) targets.explore = findExplore();
        if (!targets.reviews) targets.reviews = findReviews();
        retryCount++;
        if (retryCount < 10 && (!targets.explore || !targets.reviews)) {
            setTimeout(discoverTargets, 500);
        }
    }
    discoverTargets();

    /* ============================================================
       SHOW / HIDE based on Delivery Details scroll position
       ============================================================ */
    var isVisible = false;

    function showNav() {
        if (isVisible) return;
        isVisible = true;
        nav.style.display = 'flex';
        nav.offsetHeight; // force reflow
        nav.classList.add('visible');
        updateActive();
    }

    function hideNav() {
        if (!isVisible) return;
        isVisible = false;
        nav.classList.remove('visible');
        setTimeout(function () {
            if (!isVisible) nav.style.display = 'none';
        }, 320);
    }

    var triggerObserver = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    hideNav();
                } else {
                    var rect = deliveryEl.getBoundingClientRect();
                    if (rect.bottom < 0) {
                        showNav();
                    }
                }
            });
        },
        { threshold: 0 }
    );
    triggerObserver.observe(deliveryEl);

    /* ============================================================
       ACTIVE STATE — highlight button matching current scroll pos
       ============================================================ */
    function setActive(key) {
        buttons.forEach(function (btn) {
            if (btn.dataset.target === 'top') return; // never highlight the up arrow
            if (key && btn.dataset.target === key) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });
    }

    // IMPORTANT: This order matches the ACTUAL page layout top-to-bottom:
    //   details → reviews → explore
    var sectionOrder = ['details', 'reviews', 'explore'];

    function updateActive() {
        // Re-discover if still null
        if (!targets.explore) targets.explore = findExplore();
        if (!targets.reviews) targets.reviews = findReviews();

        var activeKey = null;

        // Walk bottom-up: the LAST section (on page) whose top is above mid-viewport wins
        for (var i = sectionOrder.length - 1; i >= 0; i--) {
            var key = sectionOrder[i];
            var el = targets[key];
            if (!el) continue;

            var rect = el.getBoundingClientRect();
            if (rect.top < window.innerHeight * 0.5) {
                activeKey = key;
                break;
            }
        }

        // If we found an active section, check if it's still partly on screen.
        // If all sections are fully scrolled past (e.g. footer), clear all highlights.
        if (activeKey) {
            var el = targets[activeKey];
            if (el) {
                var rect = el.getBoundingClientRect();
                // If the bottom of the active section is above the viewport → we're past everything
                if (rect.bottom < 0) {
                    activeKey = null;
                }
            }
        }

        setActive(activeKey);
    }

    /* ============================================================
       BUTTON CLICK HANDLERS
       ============================================================ */
    buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var key = btn.dataset.target;

            if (key === 'top') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return;
            }

            // Re-discover targets
            if (!targets.explore) targets.explore = findExplore();
            if (!targets.reviews) targets.reviews = findReviews();

            // Highlight immediately
            setActive(key);

            var target = targets[key];
            if (!target) return;

            // If Details: open the DESCRIPTION accordion
            if (key === 'details' && descriptionEl && !descriptionEl.open) {
                descriptionEl.open = true;
            }

            // Scroll with offset for the navbar height
            var navHeight = nav.offsetHeight || 44;
            var offset = navHeight + 10;
            var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        });
    });

    /* ============================================================
       SCROLL LISTENER for auto-updating active state
       ============================================================ */
    var ticking = false;
    window.addEventListener('scroll', function () {
        if (!ticking && isVisible) {
            requestAnimationFrame(function () {
                updateActive();
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    /* ============================================================
       RESIZE HANDLER — hide on desktop
       ============================================================ */
    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            if (window.innerWidth >= 750) {
                hideNav();
            }
        }, 200);
    }, { passive: true });
})();
